module.exports = __webpack_public_path__ + "static/media/delete-svgrepo-com (1).a34c66ec.svg";